export default {
	infoTitle: "Welcome back, friend. Nice to see you.",
};
